"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var Link = _react["default"].forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      style = _ref.style,
      inText = _ref.inText,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["theme", "style", "inText", "children"]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  return _react["default"].createElement(_root["default"], (0, _extends2["default"])({}, rest, {
    theme: memoTheme,
    inText: inText,
    ref: ref
  }), children);
});

Link.defaultProps = {
  inText: false
};
Link.propTypes = {
  children: _propTypes["default"].any,
  inText: _propTypes["default"].bool.isRequired,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default left
     */
    textAlign: _propTypes["default"].string,

    /**
     * @default none
     */
    textDecoration: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.transitionFunction
     */
    transitionFunction: _propTypes["default"].string,

    /**
     * @default palette.transitionDuration
     */
    transitionDuration: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverTextDecoration: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    inTextColor: _propTypes["default"].string,

    /**
     * @default none
     */
    inTextTextDecoration: _propTypes["default"].string,

    /**
     * @default hoverColor
     */
    inTextHoverColor: _propTypes["default"].string,

    /**
     * @default underline
     */
    inTextHoverTextDecoration: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
var _default = Link;
exports["default"] = _default;